import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  TextField,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { getOperatorsForField } from './tradeSchema';
import { renderValueInput } from './LineTradeFilterHelpers';

const LOGICAL_OPERATORS = [
  { value: 'AND', label: 'AND' },
  { value: 'OR', label: 'OR' },
];

const FilterConditionRow = ({ 
  condition, 
  index, 
  updateCondition, 
  updateConditionBatch,
  removeCondition, 
  availableFields 
}) => (
    <Grid container spacing={2} alignItems="center">
      {index > 0 && (
        <Grid item xs={12} sm={1.5}>
          <FormControl fullWidth size="small">
            <InputLabel>Logic</InputLabel>
            <Select
              value={condition.logicalOperator}
              label="Logic"
              onChange={(e) => updateCondition(condition.id, 'logicalOperator', e.target.value)}
            >
              {LOGICAL_OPERATORS.map((op) => (
                <MenuItem key={op.value} value={op.value}>
                  {op.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}

      <Grid item xs={12} sm={index === 0 ? 3 : 2.5}>
        <Autocomplete
          size="small"
          options={availableFields}
          value={availableFields.find(field => field.value === condition.field) || null}          onChange={(event, newValue) => {
            const fieldValue = newValue?.value || '';
            
            // Use batch update to avoid multiple state updates
            const updates = { 
              field: fieldValue,
              value: '',
              valueEnd: ''
            };
            
            if (fieldValue) {
              const operators = getOperatorsForField(fieldValue);
              updates.operator = operators.length > 0 ? operators[0].value : '';
            } else {
              updates.operator = '';
            }
            
            updateConditionBatch(condition.id, updates);
          }}
          getOptionLabel={(option) => option.label || ''}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Field"
              placeholder="Select field..."
            />
          )}
          isOptionEqualToValue={(option, value) => option.value === value.value}
        />
      </Grid>      <Grid item xs={12} sm={2}>
        <FormControl fullWidth size="small">
          <InputLabel>Operator</InputLabel>
          <Select
            value={condition.operator || ''}
            label="Operator"
            onChange={(e) => updateCondition(condition.id, 'operator', e.target.value)}
            disabled={!condition.field}          >
            {condition.field ? (
              getOperatorsForField(condition.field)
                .map((op) => (
                  <MenuItem key={op.value} value={op.value}>
                    {op.label}
                  </MenuItem>
                ))
            ) : (
              <MenuItem value="">Select field first</MenuItem>
            )}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={index === 0 ? 4.5 : 4}>
        {renderValueInput(condition, updateCondition)}
      </Grid>

      <Grid item xs={12} sm={1}>
        <IconButton onClick={() => removeCondition(condition.id)} color="error" size="small">
          <CloseIcon />
        </IconButton>      </Grid>
    </Grid>
  );

FilterConditionRow.propTypes = {
  condition: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  updateCondition: PropTypes.func.isRequired,
  updateConditionBatch: PropTypes.func.isRequired,
  removeCondition: PropTypes.func.isRequired,
  availableFields: PropTypes.array.isRequired,
};

export default FilterConditionRow;
